import { toast } from 'react-toastify';

export const handleItemAdded = item =>
  toast.success(`${item.name} dodany do koszyka!`);

export const handleItemUpdated = item =>
  toast.success(`${item.name} zaktualizowany!`);

export const handleItemRemoved = () => toast.success(`Usunięto z koszyka`);
